var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"piece",on:{"click":_vm.availableMoves}},[_c('img',{attrs:{"src":("./pieces/" + _vm.color + "_" + _vm.name + ".svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }